module.exports = __webpack_public_path__ + "img/711.9a1e091c.png";